export const LOCATION_EDGE_TYPES = [
  "LIVES_AT",
  "WORKS_AT",
  "STUDIES_AT",
  "VISITS",
  "LOCATED_AT",
];

export const LOCATION_EDGE_TYPE_LABEL = {
  LIVES_AT: "Lives at",
  WORKS_AT: "Works at",
  STUDIES_AT: "Studies at",
  VISITS: "Visits",
  LOCATED_AT: "Located at",
};

export const LOCATION_EDGE_OPTIONS = LOCATION_EDGE_TYPES.map((value) => ({
  value,
  label: LOCATION_EDGE_TYPE_LABEL[value] || value,
}));

export function isLocationEdgeType(type) {
  return LOCATION_EDGE_TYPES.includes(type);
}
